<template>
  <el-table
    :data="countTable"
    border
    style="width: 100%"
    :maxHeight="maxHeight"
    :span-method="objectSpanMethod"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column
      v-for="(item, index) in tableOrderList"
      :key="index + item.label"
      :label="item.label"
      :prop="item.prop"
      align="center"
    >
      <el-table-column
        :prop="childrenItem.prop"
        :label="childrenItem.label"
        :min-width="childrenItem.width ? childrenItem.width : '80'"
        fixed
        v-for="(childrenItem, childrenIndex) in item.childrenProps"
        :key="childrenItem.label + childrenIndex"
      >
        <template slot-scope="{ row }">
          {{ row[childrenItem.prop] }}
        </template>
      </el-table-column>
    </el-table-column>
    <el-table-column
      :key="index"
      :label="item.label"
      :prop="item.prop"
      v-for="(item, index) in tabledataList"
      :label-class-name="item.labelColor ? item.labelColor : ''"
      align="center"
    >
      <el-table-column
        :prop="childrenItem.prop"
        :label="childrenItem.label"
        :min-width="childrenItem.width ? childrenItem.width : '80'"
        fixed
        v-for="(childrenItem, childrenIndex) in item.childrenProps"
        :key="childrenItem.label + childrenIndex"
        :label-class-name="item.labelColor ? item.labelColor : ''"
        align="center"
      >
        <template slot-scope="{ row }">
          <div v-if="item.slot">
            <div class="rate-wrap">
              <span>{{ row[childrenItem.prop] }}</span>
              <span v-if="row[childrenItem.prop] && row[childrenItem.prop].endsWith('%')">
                <img
                  class="rate-wrap-icon"
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/bi/down.svg"
                  alt=""
                  v-if="parseFloat(row[childrenItem.prop]) < 0"
                />
                <img
                  class="rate-wrap-icon"
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/bi/up.svg"
                  alt=""
                  v-else
                />
              </span>
            </div>
          </div>
          <span v-else>{{ row[childrenItem.prop] }}</span>
        </template>
      </el-table-column>
    </el-table-column>
  </el-table>
</template>

<script>
import mixins from "../../mixins/index.js";
import dayjs from "dayjs";
import Empty from "../../components/empty.vue";
export default {
  name: "customerRepurchaseItemTag",
  mixins: [mixins],
  components: {
    Empty,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
    payTimeStart: {
      type: String,
      default: dayjs().startOf("month").format("YYYY-MM-DD") + " 00:00:00",
    },
    payTimeEnd: {
      type: String,
      default: dayjs().endOf("month").format("YYYY-MM-DD") + " 23:59:59",
    },
    compareType: {
      type: Number,
      default: 0,
    },
    tableCompareType: {
      type: String,
      default: "同比",
    },
  },
  data() {
    return {
      startTableTime: "", // 表头开始时间
      endTableTime: "", // 表头结束时间
      timeType: "month",
    };
  },
  computed: {
    // 统计时间范围
    tabledataList() {
      return [
        // 当前
        {
          label: this.startTableTime,
          childrenProps: [
            {
              prop: "curBuyCount",
              label: "购买人数",
              width: "120",
            },
            {
              prop: "curBuyAmount",
              label: "购买金额",
              width: "120",
            },
            {
              prop: "curRepurchaseCount",
              label: "复购人数",
              width: "120",
            },
            {
              prop: "curRepurchaseRatio",
              label: "复购率",
              width: "120",
            },
            {
              prop: "curRepurchaseAmount",
              label: "复购金额",
              width: "120",
            },
          ],
        },
        // 去年
        {
          label: this.endTableTime,
          childrenProps: [
            {
              prop: "historyBuyCount",
              label: "购买人数",
              width: "120",
            },
            {
              prop: "historyBuyAmount",
              label: "购买金额",
              width: "120",
            },
            {
              prop: "historyRepurchaseCount",
              label: "复购人数",
              width: "120",
            },
            {
              prop: "compareRepurchaseRatio",
              label: "复购率",
              width: "120",
            },
            {
              prop: "historyRepurchaseAmount",
              label: "复购金额",
              width: "120",
            },
          ],
          labelColor: "active-color",
        },
        // 同比
        {
          label: this.tableCompareType,
          childrenProps: [
            {
              prop: "compareBuyCount",
              label: "购买人数",
              width: "120",
            },
            {
              prop: "compareBuyCountRatio",
              label: "购买人数比率",
              width: "120",
            },
            {
              prop: "compareBuyAmount",
              label: "购买金额",
              width: "120",
            },
            {
              prop: "compareBuyAmountRatio",
              label: "购买金额比率",
              width: "120",
            },
            {
              prop: "compareRepurchaseCount",
              label: "复购人数",
              width: "120",
            },
            {
              prop: "compareRepurchaseCountRatio",
              label: "复购人数比率",
              width: "120",
            },
            {
              prop: "compareRepurchaseRatio",
              label: "复购率",
              width: "120",
            },
            {
              prop: "compareRepurchaseRateRatio",
              label: "复购率比率",
              width: "120",
            },
            {
              prop: "compareRepurchaseAmount",
              label: "复购金额",
              width: "120",
            },
            {
              prop: "compareRepurchaseAmountRatio",
              label: "复购金额比率",
              width: "120",
            },
          ],
          slot: true,
        },
      ];
    },
    tableOrderList() {
      return [
        {
          label: "商品标签",
          childrenProps: [
            {
              prop: "itemTagClassifyName",
              label: "标签分类",
              width: "120",
            },
            {
              prop: "itemTagName",
              label: "标签名称",
              width: "120",
            },
          ],
        },
      ];
    },
    countTable() {
      return this.tableData.map((row) => {
        const newRow = {};
        Object.keys(row).forEach((key) => {
          // 不需要处理得字段直接返回
          if (key === "itemTagClassifyName") {
            newRow[key] = row[key];
            return;
          }
          if (key === "itemTagName") {
            newRow[key] = row[key];
            return;
          }
          if (key.includes("Ratio")) {
            newRow[key] = this.formatPercent(row[key]);
          } else {
            newRow[key] = this.formatNumber(row[key]);
          }
        });
        return newRow;
      });
    },
  },
  created(){
    this.setTableTime()
  },
  methods: {
    // 设置表头时间
    setTableTime() {
      this.startTableTime =
        String(this.payTimeStart).substring(0, 10) +
        "-" +
        String(this.payTimeEnd).substring(0, 10);
      // 同比
      if (this.formData.compareType === 0) {
        this.endTableTime =
          this.getDateCommon(this.payTimeStart, "year") +
          "-" +
          this.getDateCommon(this.payTimeEnd, "year");
      } else {
        // 环比
        console.log("--- ~ this.timeType:---", this.timeType);
        if (this.timeType === "custom") {
          if (this.payTimeStart && this.payTimeEnd) {
            const start = new Date(this.payTimeStart);
            const end = new Date(this.payTimeEnd);
            const duration = end.getTime() - start.getTime();
            const prevEnd = new Date(start.getTime() - 24 * 3600 * 1000);
            const prevStart = new Date(prevEnd.getTime() - duration);
            const formatDate = (date) => {
              const y = date.getFullYear();
              const m = String(date.getMonth() + 1).padStart(2, "0");
              const d = String(date.getDate()).padStart(2, "0");
              return `${y}-${m}-${d}`;
            };
            this.endTableTime =
              formatDate(prevStart) + "-" + formatDate(prevEnd);
          } else {
            this.endTableTime = "";
          }
        } else {
          this.endTableTime =
            this.getDateCommon(this.payTimeStart, this.timeType) +
            "-" +
            this.getDateCommon(this.payTimeEnd, this.timeType);
        }
      }
    },
    getDateCommon(dateStr, type) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      switch (type) {
        case "year":
          date.setFullYear(date.getFullYear() - 1);
          break;
        case "day":
          date.setDate(date.getDate() - 1);
          break;
        case "week":
          date.setDate(date.getDate() - 7);
          break;
        case "month":
          date.setMonth(date.getMonth() - 1);
          break;
        case "quarter":
          date.setMonth(date.getMonth() - 3);
          break;
        default:
          return "";
      }
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const current = this.countTable[rowIndex].itemTagClassifyName;
        const prev = this.countTable[rowIndex - 1]
          ? this.countTable[rowIndex - 1].itemTagClassifyName
          : null;
        // 如果和上一行相同
        // 当前单元格隐藏
        if (current === prev) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
        // 计算需要合并多少行
        let rowspan = 1;
        for (let i = rowIndex + 1; i < this.countTable.length; i++) {
          if (this.countTable[i].itemTagClassifyName === current) {
            rowspan++;
          } else {
            break;
          }
        }
        return {
          rowspan,
          colspan: 1,
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rate-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  &-icon {
    width: 20px;
    height: 20px;
  }
  &-num {
    color: #999999;
    font-size: 12px;
  }
}
</style>
